import {
    // eslint-disable-next-line no-restricted-imports -- Разрешаем импортировать GalleryWithPaginator
    GalleryWithPaginator as DirectGalleryWithPaginator,
    type GalleryWithPaginatorProps,
} from '@direct-frontend/components';

export type { GalleryWithPaginatorProps };

/**
 * Прозрачная обёртка над GalleryWithPaginator из дизайн-системы.
 *
 * Для галерей с картинками используйте GalleryWithPaginatorLazy: он умеет оптимизировать загрузку изображений.
 *
 * @kind component
 */
export const GalleryWithPaginator = DirectGalleryWithPaginator;
